export const extractApiErrorMessage = (err: unknown, fallback: string): string => {
  const raw = (err as { response?: string })?.response ?? (err as { message?: string })?.message;

  if (!raw) return fallback;

  try {
    const parsed = JSON.parse(raw);
    return parsed?.message ?? fallback;
  } catch {
    return raw;
  }
};
